import { Check } from "lucide-react";
import type { PurchaseOrdersViewState } from "./purchase-order-view-state";

type Props = Pick<PurchaseOrdersViewState,
  | "createdOrder"
  | "initialRequestNo"
  | "onReturnToOffers"
  | "expanded"
  | "setFilter"
  | "setExpanded"
  | "setFocusedOrderId"
  | "recordedDeliveryOrder"
  | "setRecordedDeliveryOrder">;

export function PurchaseOrdersHeader({
  createdOrder,
  initialRequestNo,
  onReturnToOffers,
  expanded,
  setFilter,
  setExpanded,
  setFocusedOrderId,
  recordedDeliveryOrder,
  setRecordedDeliveryOrder,
}: Props) {
  return (<>
    <header className="module-header is-compact purchase-order-header">
      <div>
        {createdOrder?.requestNo || initialRequestNo ? (
          <nav
            className="purchase-order-breadcrumb"
            aria-label="İşlem bağlamı"
          >
            <button
              type="button"
              onClick={() =>
                onReturnToOffers?.(
                  createdOrder?.requestNo ?? initialRequestNo ?? "",
                )
              }
            >
              Teklifler
            </button>
            <span>/</span>
            <strong>{createdOrder?.requestNo ?? initialRequestNo}</strong>
            <span>/</span>
            <span>Sipariş</span>
          </nav>
        ) : null}
        <span className="section-kicker">TEDARİK YÜRÜTME</span>
        <h1>Sipariş operasyonu</h1>
      </div>
    </header>
    {createdOrder && expanded !== createdOrder.id ? (
      <section className="purchase-order-success" role="status">
        <div>
          <Check size={18} />
          <div>
            <strong>{createdOrder.orderNo} sipariş taslağı hazır.</strong>
            <span>Ticari özeti doğrulayıp tedarikçiye iletin.</span>
          </div>
        </div>
        <div>
          <button
            className="primary-button"
            onClick={() => {
              setFilter("ACTION");
              setExpanded(createdOrder.id);
              setFocusedOrderId(createdOrder.id);
            }}
          >
            Siparişi aç
          </button>
          <button
            className="secondary-button"
            onClick={() => onReturnToOffers?.(createdOrder.requestNo)}
          >
            Tekliflere dön
          </button>
        </div>
      </section>
    ) : null}
    {recordedDeliveryOrder ? (
      <section className="purchase-order-success" role="status">
        <div>
          <Check size={18} />
          <div>
            <strong>Teslimat kaydedildi.</strong>
            <span>
              Kayıt Kalite Kontrol Kuyruğu’na gönderildi; kalite sonucu
              tamamlanmadan sipariş sonuçlanmayacak.
            </span>
          </div>
        </div>
        <div>
          <button
            className="primary-button"
            onClick={() => {
              setFilter("MOVING");
              setExpanded(recordedDeliveryOrder.id);
              setFocusedOrderId(recordedDeliveryOrder.id);
            }}
          >
            Kalite kaydını görüntüle
          </button>
          <button
            className="secondary-button"
            onClick={() => setRecordedDeliveryOrder(null)}
          >
            Kapat
          </button>
        </div>
      </section>
    ) : null}
  </>);
}
